<!--
  @Description: 公司模板
  @Author: wang.y 
  @Date: 2022-02-25 
-->
<template>
  <div class="entity-temp" @click.stop="handleClickEntity">
    <div class="logoimg">
      <img :src="item.logo_path | logo_show('', $store.state.static_img_url + 'pic/default-logo.png')">
    </div>
    <div class="entity-info">
      <div class="top">
        <span class="name over-p1">{{item.short_name}}</span>
      </div>
      <div class="bottom">
        <span class="round over-p1" v-if="entitytype == 0">{{item.round_id | deal('round')}}</span>
        <div class="over-p1" v-if="entitytype == 1">{{item.description}}</div>
      </div>
    </div>
    <div class="entity-chk">
        <Dropdown class="cancel" placement="bottom" :transfer="true"  @on-click="handleClickAtten">
          <i class="iconfont" :class="{'green': atten_item != ''}" @click.stop="">&#xe64b;</i>
          <DropdownMenu slot="list">
            <DropdownItem>{{atten_item != '' ? '取消关注' : '添加关注'}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
    </div>
  </div>
</template>
<script>
import { entity_temp_mixins } from 'js/entity_temp_mixins'
export default {
  mixins: [ entity_temp_mixins ], 
  props: ['item', 'entitytype'],
  data() {
    return {
    }
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common2.0.stylus'
</style>